/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 * Discriminated by ``protocol`` (:class:`cal.SingleTurnChatModelProtocol`). Each protocol
 * exposes only the fields used for that integration (e.g. AINO omits
 * ``assistant_id``; CUSTOM_API includes ``endpoint_url`` and ``response_paths``).
 * @export
 * @interface PatchedSingleTurnChatInferencerPolymorphicShared
 */
export interface PatchedSingleTurnChatInferencerPolymorphicShared {
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicShared
   */
  protocol?: SingleTurnChatProtocolEnum;
}

/**
 * Check if a given object implements the PatchedSingleTurnChatInferencerPolymorphicShared interface.
 */
export function instanceOfPatchedSingleTurnChatInferencerPolymorphicShared(
  value: object,
): value is PatchedSingleTurnChatInferencerPolymorphicShared {
  return true;
}

export function PatchedSingleTurnChatInferencerPolymorphicSharedFromJSON(
  json: any,
): PatchedSingleTurnChatInferencerPolymorphicShared {
  return PatchedSingleTurnChatInferencerPolymorphicSharedFromJSONTyped(json, false);
}

export function PatchedSingleTurnChatInferencerPolymorphicSharedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedSingleTurnChatInferencerPolymorphicShared {
  if (json == null) {
    return json;
  }
  return {
    protocol: json['protocol'] == null ? undefined : SingleTurnChatProtocolEnumFromJSON(json['protocol']),
  };
}

export function PatchedSingleTurnChatInferencerPolymorphicSharedToJSON(
  value?: PatchedSingleTurnChatInferencerPolymorphicShared | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
  };
}
